import { ExerciseData } from '../../exercises';
import React from 'react';
import { Exercise } from '../../components';
import { TalkToSomeone } from '../../../articles/TalkToSomeone';

export const exerciseData22: ExerciseData = {
    ExerciseView: Module2Exercise2,
    dataKeys: [],
    questions: [],
};

function Module2Exercise2() {
    return (
        <Exercise title="Skal jeg tale med nogen?">
            <TalkToSomeone />
        </Exercise>
    );
}
